import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import { SortFilterRow } from '@common/components/Filters/FiltersRows';
import {
  CategoryTitle,
  CategoryTitleContainer,
  FilterCategory,
  FiltersList,
  FiltersListBackButton,
  FiltersListContainer,
  FiltersListTitle,
  FiltersListTitleContainer,
  MobileFiltersListContainer,
  MobileSelectedSortInfo,
  MobileSubmenuIcon,
} from '@common/components/Filters/FiltersSections/FiltersSection.styled';
import * as Icons from '@common/components/Icons';
import {
  ORDER_HIGHEST_PRICE,
  ORDER_LOWEST_PRICE,
  ORDER_NEWEST,
  ORDER_OLDEST,
  SORT_SECTION,
} from '@common/constants/filters';

function SortFiltersSection({
  openSection,
  closeSection,
  selectedOrdering,
  visibleMobileSection,
  allFiltersCount,
  transitionState,
  onItemSelect,
}) {
  const { t } = useTranslation();

  const getOrderingTitle = sortType => {
    switch (sortType) {
      case ORDER_OLDEST:
        return t('sort.oldest', 'Beliebteste');
      case ORDER_LOWEST_PRICE:
        return t('sort.lowestPrice', 'Niedrigster Preis');
      case ORDER_HIGHEST_PRICE:
        return t('sort.highestPrice', 'Höchster Preis');
      default:
        return t('sort.newest', 'Neuheiten');
    }
  };

  return (
    <FilterCategory>
      <CategoryTitleContainer onClick={() => openSection(SORT_SECTION)}>
        <CategoryTitle>{t('filters.sortTitle', 'Sortieren')}</CategoryTitle>
        <MobileSelectedSortInfo>
          {getOrderingTitle(selectedOrdering)}
        </MobileSelectedSortInfo>
        <MobileSubmenuIcon>
          <Icons.ArrowForwardNavigation />
        </MobileSubmenuIcon>
      </CategoryTitleContainer>
      <FiltersListContainer
        transitionState={transitionState}
        isMobileSectionOpen={visibleMobileSection === SORT_SECTION}
        hasFiltersSelected={allFiltersCount > 0}
      >
        <FiltersListTitleContainer>
          <FiltersListBackButton
            onClick={() => {
              closeSection();
            }}
          >
            <Icons.ArrowBackwardNavigation
              width="11"
              height="20"
            />
          </FiltersListBackButton>
          <FiltersListTitle>
            {t('filters.sortTitle', 'Sortieren')}
          </FiltersListTitle>
        </FiltersListTitleContainer>

        <MobileFiltersListContainer>
          <FiltersList>
            <SortFilterRow
              value={ORDER_NEWEST}
              title={getOrderingTitle(ORDER_NEWEST)}
              selected={selectedOrdering === ORDER_NEWEST}
              onSelect={onItemSelect}
            />
            {/* <SortFilterRow */}
            {/*  value={ORDER_OLDEST} */}
            {/*  title={getSortTitle(ORDER_OLDEST)} */}
            {/*  selected={selectedSort === ORDER_OLDEST} */}
            {/*  onSelect={onItemSelect} */}
            {/* /> */}
            <SortFilterRow
              value={ORDER_LOWEST_PRICE}
              title={getOrderingTitle(ORDER_LOWEST_PRICE)}
              selected={selectedOrdering === ORDER_LOWEST_PRICE}
              onSelect={onItemSelect}
            />
            <SortFilterRow
              value={ORDER_HIGHEST_PRICE}
              title={getOrderingTitle(ORDER_HIGHEST_PRICE)}
              selected={selectedOrdering === ORDER_HIGHEST_PRICE}
              onSelect={onItemSelect}
            />
          </FiltersList>
        </MobileFiltersListContainer>
      </FiltersListContainer>
    </FilterCategory>
  );
}

SortFiltersSection.defaultProps = {
  visibleMobileSection: null,
};
SortFiltersSection.propTypes = {
  allFiltersCount: PropTypes.number.isRequired,
  closeSection: PropTypes.func.isRequired,
  onItemSelect: PropTypes.func.isRequired,
  openSection: PropTypes.func.isRequired,
  selectedOrdering: PropTypes.string.isRequired,
  transitionState: PropTypes.string.isRequired,
  visibleMobileSection: PropTypes.string,
};

export { SortFiltersSection };
